export class customersData {
    name: string;
    profileImage: string;
    job: string;
    text: string;
    video: string;
}

export let customersDataHe: customersData[] =
    [
        {
            name: "סטיב",
            profileImage: "assets/images/profile-customers/סטיב.png",
            job: "בעלים של חנות צעצועים בניו יורק ארהב",
            text: "חשוב לי מאוד לספק חוויה מרגשת ללקוחות שלי: הספין טו ווין מאפשר לנו לתת ללקוחות רגע מהנה, והכי חשוב משהו שמחייב אותו לחזור אלינו לקניה נוספת בשביל לממש את המתנה, מה שהכי חשוב לי זה קבלת כתובות המייל של הלקוחות שלי זה מאפשר לי לעדכן אותם בכל פעם שיש לי עבורם מבצע שווה וכדאי",
            video: "https://stwstorageaccount.blob.core.windows.net/videospintowin/SteeveRecommendation.mp4"
        },
        {
            name: "ג'ון",
            profileImage: "assets/images/profile-customers/ג'ון יועץ עסקי.png",
            job: "יועץ עסקי ומנטור מכירות",
            text: "זה פשוט מגדיל ללקוחות שלי את היקף המכירות, זה קל לשימוש ובמחיר זול, ואני ממש ממליץ לכם לנסות את זה, וזה פשוט פלטפורה מדהימה להגדלת העסק שלכם",
            video: "https://stwstorageaccount.blob.core.windows.net/videospintowin/JhonRecommendation.mp4"
        },
        {
            name: "יודה",
            profileImage: "assets/images/profile-customers/יודה.png",
            job: "מסעדת PRIME NINETY FIVE ",
            text: "הספין טו ווין עוזר לנו מאוד להחזיר לקוחות מרוצים אלינו לעסק. לאחרונה גילינו תופעה מדהימה, הספין טו ווין העלה לנו את הדירוג בגוגל, המשתמשים מעניקים לנו דירוג של 5 כוכבים",
            video: null
        },

        {
            name: "ג'ורדי",
            profileImage: "assets/images/profile-customers/מסעדת מיוחס.png",
            job: "מסעדת מיוחס",
            text: "זה כיף ללקוחות הם מקבלים מתנה, וזה בונה לנו מאגר לקוחות רציני לשיווק עתידי. יש הרבה לקוחות שזה גורם להם להכיר אותנו ולהגיע דווקא אלינו למסעדה, זה ווין ווין לכל הצדדים",
            video: null
        },

    ]

export let customersDataEn: customersData[] =
    [
        {
            name: "Joan",
            profileImage: "assets/images/profile-customers/ג'ון יועץ עסקי.png",
            job: "Business Consultant & Sales Mentor",
            text: "Spin to Win has increased my customers' sales volume. It's cheap and easy to use, and I really recommend you give it a try. It's just an amazing platform for growing your business.",
            video: "https://stwstorageaccount.blob.core.windows.net/videospintowin/SteeveRecommendation.mp4"
        },
        {
            name: "Steve",
            profileImage: "assets/images/profile-customers/סטיב.png",
            job: "toy store owner, New York City",
            text: "We try to give every customer an exciting experience in our store. Spin to Win helps us make it fun for them, but they have to come back to the store again to use their voucher, and we collect their email addresses to use for future promotions.",
            video: "https://stwstorageaccount.blob.core.windows.net/videospintowin/JhonRecommendation.mp4"
        },
        {
            name: "Judah",
            profileImage: "assets/images/profile-customers/יודה.png",
            job: "owner of Prime 95 Restaurant, New Jersey",
            text: "Spin to Win has helped us bring happy customers back to our business. We saw that it even helped us to rank on Google, because the customers gave us 5-star ratings because they loved the game!",
            video: null
        },

        {
            name: "Jordan",
            profileImage: "assets/images/profile-customers/מסעדת מיוחס.png",
            job: "restaurant owner, Chicago",
            text: "It’s fun for customers to win prizes, and it helped us build a database of customers for future marketing. Spin to Win has helped customers to remember us and they come back to the restaurant to play again. It’s a win-win for everyone!",
            video: null
        },

    ]